import { useState } from 'react';
import { api } from '../../api';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { token } = await api.login(form.username, form.password);
      // Clear all stored data from any previous session before setting new token
      localStorage.clear();
      localStorage.setItem('admin_token', token);
      // Full page reload ensures React context resets cleanly for the new account
      window.location.href = '/admin/dashboard';
    } catch (err) {
      setError(err.message || 'Invalid credentials');
      setLoading(false);
    }
  };

  return (
    <div className="admin-login">
      <div className="admin-login-card">
        <div className="admin-login-logo">
          <img src="/images/logo-site.png" alt="logo" />
          <h2>Admin Panel</h2>
          <p>Arafah Day Sermon Platform</p>
        </div>
        <form onSubmit={submit}>
          <div className="a-field">
            <label>Username</label>
            <input
              type="text"
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              placeholder="admin"
              required
              autoComplete="username"
            />
          </div>
          <div className="a-field">
            <label>Password</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder="••••••••"
              required
              autoComplete="current-password"
            />
          </div>
          {error && <p className="a-error">{error}</p>}
          <button className="a-btn-primary" type="submit" disabled={loading} style={{ marginTop: 20 }}>
            {loading ? 'Logging in…' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
